import { Component } from "react";
import styled from "styled-components";
import { RitualLogos } from "../../utils/react-svg";
import MagicLink from "../MagicLink";

const RitualLogo = styled(MagicLink)``;

export default class CloseButton extends Component {
  render() {
    return (
      <RitualLogo href={"https://ritual.com"} title={"Ritual"}>
        <RitualLogos.RitualLogo />
      </RitualLogo>
    );
  }
}
